export default __webpack_public_path__ + "38e8d2602f810d7ca7882ce50ef0d391.svg";